import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../lib/api";
import { HardHat, Warning, CheckCircle, Info, ArrowRight } from "@phosphor-icons/react";

const TONE = { red: "border-red-300 bg-red-50/60 dark:bg-red-950/20", amber: "border-amber-300 bg-amber-50/60 dark:bg-amber-950/20", green: "border-emerald-300 bg-emerald-50/60 dark:bg-emerald-950/20" };
const LEVEL = { red: { icon: Warning, cls: "text-red-600" }, amber: { icon: Warning, cls: "text-amber-600" }, blue: { icon: Info, cls: "text-sky-600" } };

/** Dashboard tile: the HSE health banner plus the three most pressing attention items, each linking into the hub. */
export default function HseDashboardTile() {
  const [d, setD] = useState(null);
  useEffect(() => { API.get("/hse/overview").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return null;
  const top = d.attention.slice(0, 3);
  return (
    <div className={`border rounded-md p-4 ${TONE[d.score.tone]} animate-fade-in`} data-testid="dashboard-hse-tile">
      <div className="flex flex-wrap items-center gap-3">
        <span className="h-9 w-9 rounded-md bg-amber-400 text-slate-900 inline-flex items-center justify-center shrink-0"><HardHat size={18} weight="bold" /></span>
        <div className="flex-1 min-w-[200px]">
          <p className="text-sm font-semibold inline-flex items-center gap-1.5" data-testid="dashboard-hse-score">
            {d.score.tone === "green" ? <CheckCircle size={15} weight="fill" className="text-emerald-600" /> : <Warning size={15} weight="fill" className={d.score.tone === "red" ? "text-red-600" : "text-amber-600"} />}
            Health &amp; Safety — {d.score.label}
          </p>
          <p className="text-xs text-muted-foreground">{d.score.detail} · {d.incidents.days_since_injury == null ? "no injuries recorded" : `${d.incidents.days_since_injury} day${d.incidents.days_since_injury === 1 ? "" : "s"} since the last injury`} · {d.documents.essentials_approved}/{d.documents.essentials_total} essential documents approved</p>
        </div>
        <Link to="/health-safety?tab=overview" className="text-xs font-medium text-primary hover:underline inline-flex items-center gap-1 shrink-0" data-testid="dashboard-hse-open">HSE overview <ArrowRight size={12} /></Link>
      </div>
      {top.length > 0 && (
        <ul className="mt-3 grid sm:grid-cols-3 gap-2" data-testid="dashboard-hse-attention">
          {top.map((a, i) => {
            const L = LEVEL[a.level];
            return (
              <li key={i}>
                <Link to={`/health-safety?tab=${a.tab}`} className="flex items-start gap-2 text-xs bg-background/70 border border-border rounded-md px-2.5 py-2 hover:border-primary/60 transition-colors h-full" data-testid={`dashboard-hse-attention-${i}`}>
                  <L.icon size={14} weight="fill" className={`${L.cls} shrink-0 mt-0.5`} />
                  <span className="flex-1 leading-snug">{a.text}</span>
                </Link>
              </li>
            );
          })}
          {d.attention.length > 3 && <li className="sm:col-span-3 text-[11px] text-muted-foreground text-right">+{d.attention.length - 3} more in the HSE overview</li>}
        </ul>
      )}
    </div>
  );
}
